module.exports = __webpack_public_path__ + "media/AG-Banner.ce200580.mp4";